module.exports = {"global":{}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/pt/global-variables.json
// module id = 318
// module chunks = 120